import { useNavigate } from "react-router-dom";

function Button() {
  const navigate = useNavigate();

  const mensaje = `Gracias por contactar a Industrial Business Clusters, trabajamos para ti en acelerar las ventas de tu negocio, en un momento te atenderemos.`;

  const whatsappUrl = `https://api.whatsapp.com/send?phone=5215549769532&text=${encodeURIComponent(
    mensaje
  )}`;

  return (
    <button
      onClick={() => window.open(whatsappUrl)}
      aria-label="Contactar por WhatsApp"
      className="h-14 w-14 sm:h-16 sm:w-16 md:h-20 md:w-20 bg-[#25D366] hover:bg-[#20BA5A] fixed right-3 sm:right-4 md:right-5 bottom-16 sm:bottom-20 shadow-xl text-white rounded-full z-50 flex items-center justify-center transition-all duration-300"
    >
      <i className="bx bxl-whatsapp text-4xl sm:text-5xl md:text-6xl"></i>
    </button>
  );
}

export default Button;
